<template>
    <div v-if="show" class="full-page-loader">
        <div class="loader-content">
            <div class="loader-spinner">
                <div class="spinner"></div>
            </div>
            <div class="loader-text">
                <h3 class="text-lg font-semibold text-gray-900 mb-2">Switching Account</h3>
                <p class="text-gray-600">Loading user data...</p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    show: boolean;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.full-page-loader {
    @apply fixed inset-0 z-[9999] flex items-center justify-center bg-white;
    
    .loader-content {
        @apply flex flex-col items-center gap-6;
        
        .loader-spinner {
            @apply relative;
            
            .spinner {
                @apply w-12 h-12 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin;
            }
        }
        
        .loader-text {
            @apply text-center;
        }
    }
}
</style> 